export const WALLETS_REFERAL = {
  binance: 'https://accounts.binance.com/register?ref=75558686',
  bybit: 'https://www.bybit.com/',
  testbinance: 'https://accounts.binance.com/register?ref=75558686',
  testbybit: 'https://www.bybit.com/',
};
